import React from 'react';
import { Card } from 'react-bootstrap';
import { lowerCase, startCase } from 'lodash';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import percentage from 'percentage';

import { amountToUsd, amountToKhr } from '@utils/currency';
import { PersonalAccidentQuote } from '@models/PersonalAccidentQuote';

import style from './style.module.scss';

type Props = Pick<
PersonalAccidentQuote,
'personalAccidentPlanName' | 'totalPremium' | 'totalPremiumKhr' | 'discountPercentage' | 'insurer' | 'adminFeeAmount'
>;

const PersonalAccidentQuotePremiumCardBody = ({
  personalAccidentPlanName,
  totalPremium,
  totalPremiumKhr,
  discountPercentage,
  insurer,
  adminFeeAmount,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Card.Body>
      <div className={classNames('position-relative mb-4', style.insurerLogoWrapper)}>
        <img
          src={insurer.logo}
          className={classNames('position-absolute top-50 start-0 translate-middle-y', style.insurerLogo)}
        />
      </div>

      <ul className={classNames('list-unstyled pb-2 border-bottom', style.borderBottomDash)}>
        <li className="d-flex justify-content-between">
          <span className="fw-bold">{t('common:policyTerm')}:</span>
          <span>1 {t('common:year')}</span>
        </li>
        <li className="d-flex justify-content-between">
          <span className="fw-bold">{t('common:premiumPaymentTerm')}:</span>
          <span>1 {t('common:year')}</span>
        </li>
      </ul>

      <ul className={classNames('list-unstyled pb-2 border-bottom', style.borderBottomDash)}>
        <li className="d-flex justify-content-between">
          <span className="fw-bold">{t('common:planType')}:</span>
          <span>{personalAccidentPlanName}</span>
        </li>
      </ul>

      {!!discountPercentage && (
        <ul className={classNames('list-unstyled pb-2 border-bottom', style.borderBottomDash)}>
          <li className="d-flex justify-content-between">
            <span className="fw-bold">{t('common:discount')}:</span>
            <span>{percentage(discountPercentage / 100)}</span>
          </li>
        </ul>
      )}

      <ul className={classNames('list-unstyled pb-2 border-bottom', style.borderBottomDash)}>
        <li className="d-flex justify-content-between">
          <span className="fw-bold">{startCase(t('common:adminFeeAmount'))}:</span>
          <span>{amountToUsd(adminFeeAmount)}</span>
        </li>
      </ul>

      <ul className={classNames('list-unstyled pb-2 mb-0')}>
        <li className="d-flex justify-content-between">
          <span className="fw-bold">{t('common:youWillPay')}:</span>
          <span>
            {amountToUsd(totalPremium)}/{lowerCase(t('common:year'))}
          </span>
        </li>
        <li className="d-flex justify-content-between">
          <span>&nbsp;</span>
          <span>
            {amountToKhr(totalPremiumKhr)}/{lowerCase(t('common:year'))}
          </span>
        </li>
      </ul>
    </Card.Body>
  );
};

export { PersonalAccidentQuotePremiumCardBody };
